import { Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { describeDeliveryStatus } from './deliveryStatus';
import type { ConversationChannelLike, ConversationDeliveryStatusLike } from './types';

export interface DeliveryStatusIconProps {
  status: ConversationDeliveryStatusLike | null | undefined;
  reason?: string | null;
  attempts?: number | null;
  channel: ConversationChannelLike;
}

/**
 * The delivery glyph ALONE (icon + tooltip + `aria-label`) — the meta-line indicator shared by the
 * timeline bubble and Customer 360's compact list. Pair with a caller-rendered caption from
 * {@link describeDeliveryStatus} (`./deliveryStatus`) where a secondary line belongs (design §11.5).
 */
export function DeliveryStatusIcon({ status, reason, attempts, channel }: DeliveryStatusIconProps) {
  const { t } = useTranslation('conversations');
  const description = describeDeliveryStatus(status, reason, attempts, channel, t);
  if (!description) {
    return null;
  }
  const { label, color, Icon } = description;
  return (
    <Tooltip title={label} describeChild>
      <Box
        component="span"
        aria-label={label}
        sx={{ color, display: 'inline-flex', alignItems: 'center' }}
      >
        <Icon fontSize="inherit" />
      </Box>
    </Tooltip>
  );
}
